import axiosInstance from "./axiosInstance";
import Cookies from "js-cookie";

function toServiceError(error) {
  const message =
    (typeof error?.response?.data?.message === "string" &&
      error.response.data.message) ||
    (typeof error?.message === "string" && error.message) ||
    "Request failed";
  const err = new Error(message);
  err.status = error?.response?.status;
  err.data = error?.response?.data;
  return err;
}

const CategoryService = {
  getAllCategory: async () => {
    try {
      const response = await axiosInstance.get(`/category/all-categories`, {
        // Public endpoint: do not attach Authorization header
        headers: { "X-Skip-Auth": true },
        skipAuth: true,
      });
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
  getCategoryById: async (id) => {
    try {
      const response = await axiosInstance.get(`/category/${id}`);
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
  createCategory: async (payload) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);

      const response = await axiosInstance.post(
        `/category/create`,
        payload, // ✅ Directly send JSON
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );

      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },

  updateCategory: async (id, payload) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.put(
        `/category/${id}`,
        payload,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },

  deleteCategory: async (id) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.delete(
        `/category/${id}`,
        token ? { headers: { Authorization: `${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
};

export default CategoryService;
